export const TokensIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 15C9.825 15 8.40625 14.4188 7.24375 13.2563C6.08125 12.0938 5.5 10.675 5.5 9C5.5 7.325 6.08125 5.90625 7.24375 4.74375C8.40625 3.58125 9.825 3 11.5 3C13.175 3 14.5938 3.58125 15.7563 4.74375C16.9188 5.90625 17.5 7.325 17.5 9C17.5 10.675 16.9188 12.0938 15.7563 13.2563C14.5938 14.4188 13.175 15 11.5 15ZM5.5 14.8125C4.175 14.4625 3.09375 13.75 2.25625 12.675C1.41875 11.6 1 10.375 1 9C1 7.625 1.41875 6.4 2.25625 5.325C3.09375 4.25 4.175 3.5375 5.5 3.1875V4.7625C4.6 5.075 3.875 5.61875 3.325 6.39375C2.775 7.16875 2.5 8.0375 2.5 9C2.5 9.9625 2.775 10.8313 3.325 11.6063C3.875 12.3813 4.6 12.925 5.5 13.2375V14.8125ZM11.5 13.5C12.75 13.5 13.8125 13.0625 14.6875 12.1875C15.5625 11.3125 16 10.25 16 9C16 7.75 15.5625 6.6875 14.6875 5.8125C13.8125 4.9375 12.75 4.5 11.5 4.5C10.25 4.5 9.1875 4.9375 8.3125 5.8125C7.4375 6.6875 7 7.75 7 9C7 10.25 7.4375 11.3125 8.3125 12.1875C9.1875 13.0625 10.25 13.5 11.5 13.5Z"
        fillOpacity="0.6"
      />
    </svg>
  );
};
